var React = require('react');

function ArrowDownInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M900.626,943.9l10.086,7.237L920.8,943.9","transform":"translate(-899.579 -942.852)","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5"}));
}

ArrowDownInline.defaultProps = {"width":"22.265","height":"9.034","viewBox":"0 0 22.265 9.034"};

module.exports = ArrowDownInline;

ArrowDownInline.default = ArrowDownInline;
